import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GlobalStateService } from '../global/global-state.service';

@Injectable({
  providedIn: 'root'
})
export class ChargeService {

  private service_type = "charges"
  public baseURL = '';

  constructor(private _globalStateService: GlobalStateService, private _http: HttpClient) {
    this.baseURL = this._globalStateService.GetBaseEndpoint('base');
  }

  GetData(page_number: string, search: string = '', filters: Record<string, any> = {}): Observable<any> {
    let params = new URLSearchParams(filters).toString();
    const url = `${this.baseURL}/${this.service_type}?page=${page_number}&search=${search}&${params}`;
    return this._http.get<any>(url);
  }

  GetDataById(id: any): Observable<any> {
    const url = `${this.baseURL}/${this.service_type}/${id}`;
    return this._http.get<any>(url);
  }

  DeleteDataById(id: any): Observable<any> {
    const url = `${this.baseURL}/${this.service_type}/${id}`;
    return this._http.delete<any>(url);
  }

  AddData(data: any): Observable<any> {
    const url = `${this.baseURL}/${this.service_type}`;
    return this._http.post<any>(url, data);
  }

  UpdateData(id: string, data: any): Observable<any> {
    const url = `${this.baseURL}/${this.service_type}/${id}`;
    return this._http.patch<any>(url, data);
  }
}
